import type { ChainStep } from '@/types/content';

interface ChainTimelineProps {
  steps: readonly ChainStep[];
  accentLast?: boolean;
}

export default function ChainTimeline({ steps, accentLast = true }: ChainTimelineProps) {
  return (
    <ol className="relative pl-6 md:pl-8">
      <span className="absolute left-[7px] md:left-[11px] top-2 bottom-2 w-[2px] bg-background-300" aria-hidden="true" />
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1;
        const highlight = accentLast && isLast;
        return (
          <li key={`${step.date}-${index}`} className={`relative ${isLast ? '' : 'pb-7'}`}>
            <span
              className={`absolute -left-6 md:-left-8 top-1 w-4 h-4 rounded-full border-2 border-background-50 flex items-center justify-center ${
                highlight ? 'bg-accent-500' : 'bg-primary-500'
              }`}
              aria-hidden="true"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-background-50" />
            </span>
            <div className="flex flex-wrap items-center gap-2">
              <span
                className={`px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${
                  highlight ? 'bg-accent-100 text-accent-800' : 'bg-primary-100 text-primary-700'
                }`}
              >
                {step.date}
              </span>
              <h4 className="font-heading font-bold text-foreground-950 text-sm md:text-base">{step.title}</h4>
            </div>
            <p className="mt-2 text-sm leading-7 text-foreground-600">{step.desc}</p>
          </li>
        );
      })}
    </ol>
  );
}